import 'material-design-icons/iconfont/material-icons.css';
import * as React from 'react';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import "./semantic/dist/semantic.min.css";
// tslint:disable-next-line:ordered-imports
import './App.css';
import Following from './containers/Following';
import Home from './containers/Home';
import Movie from './containers/Movie';
import Search from './containers/Search';
import Watchlist from './containers/Watchlist';
// tslint:disable-next-line:ordered-imports
import { withApollo } from 'react-apollo';


class App extends React.Component<any, any> {
  public searchFieldForm: any;
  public searchField: any;

  constructor(props) {
    super(props);
    this.state = {
      authenticated: (window as any).app.auth().currentUser !== null
    };
  }

  public render() {
    return (
      <>
        <Router>
          <div className="App">
            <Route exact={true} path="/" render={this.redirectToUpcoming} />
            <Route exact={true} path="/released" component={Home} />
            <Route exact={true} path="/upcoming" component={Home} />

            <Route path="/movie/:movieId" component={Movie} />

            <Route exact={true} path="/following/" render={this.redirectToFollowingUpcoming} />
            <Route path="/following/released" component={Following} />
            <Route path="/following/upcoming" component={Following} />

            <Route exact={true} path="/watchlist/" render={this.redirectToWatchlistUpcoming} />
            <Route path="/watchlist/released" component={Watchlist} />
            <Route path="/watchlist/upcoming" component={Watchlist} />

            <Route path="/search" component={Search} />
          </div>
        </Router>
      </>
    );
  }

  private redirectToUpcoming = () => <Redirect to="/upcoming" />;
  private redirectToFollowingUpcoming = () => <Redirect to="/following/upcoming" />;
  private redirectToWatchlistUpcoming = () => <Redirect to="/watchlist/upcoming" />;
}

export default withApollo(App);




// WEBPACK FOOTER //
// ./src/App.tsx